import script from "./experienceAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./experienceAccount.vue?vue&type=script&setup=true&lang=js"

import "./experienceAccount.vue?vue&type=style&index=0&id=615bedf0&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615bedf0"]])

export default __exports__